import createReactComponent from '../createReactComponent';
export default createReactComponent('oval', 'IconOval', [
  ['path', { d: 'M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0', key: 'svg-0' }],
]);
